import { DCBaseWheelEvent } from "./DCBaseWheelEvent.js";
export class DCBaseWheelDownEvent extends DCBaseWheelEvent {
    eventType = "wheel-down";
    inputType = "mouse";
    constructor() {
        super();
    }
}
